module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-2x1-4ec3593fe16be1ca342a4e0d62be9c87.jpg";